import { connect } from 'react-redux';
import * as R from 'ramda';

import {
  resetCardFilters,
  setFilters,
} from 'feature/loading-management/filters/store/filtersSlice';
import Filters from './Filters';
import {
  getProductOrLocationOptions,
  getStateOptions,
  getStoreValueByProp,
} from '../../store/authorizationSequencingSlice';

const mapState = R.applySpec({
  authorizationSequencingPending: getStoreValueByProp(['authorizationSequencingPending']),
  filters: R.o(
    R.pick(['loadingAllowed', 'nameShort', 'state']),
    R.path(['loadingManagement', 'filters'])
  ),
  productOrLocationOptions: getProductOrLocationOptions,
  stateOptions: getStateOptions,
});

const mapDispatch = {
  resetCardFilters,
  setFilters,
};

export default connect(mapState, mapDispatch)(Filters);
